export const locale = {
    lang: 'pt',
    data: {
      'PRINCIPAL': {
        'TITULO': 'Status da pesquisa',
        'SUBTITULO': 'Você pode revisar e acompanhar as informações das pesquisas aplicadas em um ou mais produtos da empresa',
        'COPY_URL_RES':'Copiar URL da SuccesGo',
      },
      'MENU_PRODUCTOS': {
        'TITULO': 'Produtos comprados',
        'CARGANDO': 'Carregando lista de produtos',
        'NOMBREPULSO': 'Pulso',
        'TIPOS': {
          'certificar': {
            'NOMBRE': 'Certificar',
            'SUBTIPOS': {
              'v1': 'Certificar v1',
              'v2': 'Certificar v2.0',
              'v3': 'Certificar v3.0',
            }
          },
          'certificacionesAdicio': {
            'NOMBRE': 'Certificações adicionais',
            'SUBTIPOS': {
              'v1Amco': 'AMCO',
              'v2TD': 'Trabalho decente',
              'v3PE': 'Primeiro Emprego',
            }
          },
          'medir': {
            'NOMBRE': 'Medir',
            'SUBTIPOS': {
              'v1': 'Medida v1',
              'v2': 'Medida melhorada',
              'v3': 'Medir + MST',
              'v4': 'Medir por áreas',
              'v5': 'Medida por líderes',
              'v6': 'Medir por dimensões',
              'v7': 'Medida para certificar',
              'v8': 'Medida 3.0',
            }
          },
          'pulse': {
            'NOMBRE': 'Pressione Verificar',
            'SUBTIPOS': {
              'v1': 'Verificação de pulso v1.0',
              'v2': 'Pulse Check v3.0',
            }
          },
          'focus': {
            'NOMBRE': 'Área de foco',
            'SUBTIPOS': {
            }
          },
          'nom35': {
            'NOMBRE': 'NOM-035',
            'SUBTIPOS': {
              'v1': 'NOM-035',
              'v2': 'NOM-035 v3',
            }
          },
          'cgoExpress': {
            'NOMBRE': 'Cultural Go Express',
            'SUBTIPOS': {
              'cgoExpress': 'Cultural Go Express'
            }
          },
          'resulGoFlow': {
            'NOMBRE': 'goFlow resultados',
            'SUBTIPOS': {
              'resulGoFlow': 'goFlow resultados'
            }
          },
        }
      },
      'DETALLES': {
        'TITULO': 'Detalhes do produto',
        'PRODUCTO': 'Produtos:',
        'PROGRESO': 'Progresso',
        'RESTANTE': 'Tempo restante',
        'DIASREST': 'Dias restantes:',
        'PANELFIJO': 'Mostrar como painel fixo',
        'SURVEYTOKEN': 'Token de pesquisa',
        'ACCOUNT_ID': 'ID da conta',
        'OPORTUNITY_ID': 'Oportunidade identificação',
        'FECHAS': {
          'lanzamiento': 'Data de lançamento',
          'cierre': 'Data limite',
          'prorroga': 'Data de extensão',
          'recordatorio':'Lembretes',
          'avisos':'Comunicação pré-investigação',
        },
        'AVANCES': {
          'NORMAL': 'Respostas antecipadas:',
          'MAS50': 'Avance acima de 50:',
          'MAS50_2': 'Mais de 50 - Respostas Antecipadas',
          'MENOS50': 'Avançar menos de 50:',
          'MENOS50_2': 'Menos de 50 - respostas antecipadas'
        }
      },
      'CONTENIDO': {
        'BOTONES': {
          'VERPROD_1': 'Escolha um produto',
          'VERPROD_2': 'Veja outro produto',
          'OCULTAR': 'Esconder'
        },
        'PREVIA': {
          'TITULO': 'Status da pesquisa por produto',
          'SUBTITULO': 'A lista de produtos adquiridos por esta empresa é mostrada no menu à esquerda desta tela. Para ver o status da pesquisa para cada produto, clique em uma categoria de produto e escolha um ano. Depois disso, os detalhes da pesquisa selecionada serão exibidos, apenas se o produto selecionado já tiver uma pesquisa inicializada',
          'CARGANDO': 'Recuperando o status do produto selecionado, por favor aguarde'
        },
        'ESTADOS': {
          'NOCREADA': 'Este produto ainda não tem uma pesquisa criada',
          'NOINICIADA': 'Pesquisa não habilitada'
        },
      },
      'COLABORADORES': {
        'TAB': 'Lista de colaboradores',
        'CARGANDO': 'Carregando lista de colaboradores',
        'TABLA': {
          'TITULO': 'Lista de colaboradores',
          'NOINFO': 'Sem informação',
          'COLUMNAS': {
            'NOMBRE': 'Nome completo',
            'EMAIL': 'E-mail',
            'PASS': 'Senha',
            'STATUS': 'Estado atual',
            'FECHA_INI': 'Data de início',
            'FECHA_FIN': 'Data de término',
            'ACCIONES': 'Ações'
          },
          'TOOLTIPS': {
            'ACCIONES': 'Ações disponíveis',
            'EMAILS': 'Log de e-mail',
          },
        },
        'ACCIONES': {
          'TITULO': 'Ações disponíveis',
          'LISTA': {
            'primerosColab': 'Veja os primeiros 1000',
            'buscarColab': 'Encontre um colaborador',
            'nuevoColab': 'Adicionar novo colaborador',
            'enviaReco': 'Enviar lembretes',
            'bajarColab': 'Baixar lista de colaboradores',
          }
        },
        'SENDGRID': {
          'TITULO': 'Log de e-mail enviado',
          'SUBTITULO': 'Escolha um tipo de assunto da lista para mostrar o histórico de e-mails enviados',
          'SELOPC': 'Selecione uma opção',
          'INFOASUNTO': {
            'TITULO': 'Informação de correio',
            'CARD': {
              'from': 'Enviar para',
              'to': 'A partir de',
              'subject': 'Assunto da mensagem'
            },
            'HISTORIAL': {
              'TITULO': 'Histórico de envio de email',
              'SUBTITULO': 'NOTA: A data / hora exibida na lista é definida para a hora local de',
              'VECESABIERTO': 'Horários abertos',
              'ULTIMOEVENTO': 'Último evento',
              'NORECORDS': 'Seu histórico de e-mail não está disponível',
              'STATUS': {
                'ABIERTO': 'Email enviado',
                'NOENVIADO': 'Ainda não foi enviado'
              }
            }
          },
          'BOTONES': {
            'BACK': 'Volte'
          }
        },
        'ACCIONESUSUARIO': {
          'TITULO': 'Ações disponíveis',
          'SUBTITULO': 'A lista a seguir mostra a lista de ações disponíveis para o usuário',
          'CARGANDO': 'Carregando ações disponíveis',
          'LISTA': {
            'modificar': 'Modifica os dados do colaborador selecionado',
            'borrar': 'Exclua o colaborador selecionado',
            'invitacion': 'Reenviar convite',
            'recordatorio': 'Reenviar lembrete',
            'respuestas': 'Remover resposta à pesquisa',
            'resetSur': 'Reiniciar o acesso ao inquérito',
          }
        },
        'MODALES': {
          'BUSCAR': 'Digite o nome do colaborador para pesquisar',
          'BUSCAR_BOT': 'Procurar',
          'MINIMARECO': 'Lembretes só podem ser enviados a partir da data de lançamento da pesquisa',
          'GENERAEXCEL': 'Gerando arquivo excel de colaboradores, aguarde um momento',
          'NOANSWERS': 'Nenhuma resposta foi encontrada para este participante',
          'ENVIOCORREO': 'Enviando a mensagem, espere um momento',
          'BORRARESP': 'Excluindo as respostas deste usuário, por favor, aguarde um momento',
        },
        'EXCEL': {
          'TITUARCHIVO': 'Lista de colaboradores',
          'COLUMNAS': {
            'name': 'Nome do colaborador',
            'email': 'E-mail',
            'id_status': 'Status da pesquisa',
            'start_date': 'Data de início',
            'end_date': 'Data de término',
          }
        }
      },
      'ACCIONES': {
        'TAB': 'Ações',
        'TITULO': 'Lista de ações disponíveis por categoria',
        'CATEGORIAS': {
          'encuesta': 'Enquete',
          'filemanager': 'Gerenciador de arquivos',
          'resultados': 'Resultados',
          'webcompro': 'Perfil da empresa na web',
        },
        'LISTA': {
          'surveyCheck': 'Verificando a pesquisa',
          'surveyDown': 'Baixar pesquisa',
          'goSurvey': 'Vá para a pesquisa',
          'goCounting': 'Vá para o Portal de Contagens',
          'goCounting_more50': 'Vá para o Portal de Contagens +50',
          'goCounting_less50': 'Vá para o Portal de Contagens -50',
          'genCountingUrl': 'Gerar link externo para o portal de contagens',
          'copyCountingUrl': 'Copie o link externo para o portal de contagens',
          'updateCounting': 'Sincronizar com portal de contagens',
          'addPro': 'Adicionar extensão',
          'verRecord': 'Lembretes gravados',
          'surveyClose': 'Fechar pesquisa',
          'surveyOpen': 'Pesquisa aberta',
          'processRes': 'Resultados do processo',
          'goPriv': 'Ver pasta privada',
          'goPub': 'Ver pasta pública',
          'verRes': 'Ver resultados',
          'upNameIcon': 'Atualizar nome e logotipo',
          'regCertifi': 'Certificado de regeneração',
          'goSurveyMas50': 'Go to survey +50',
          'goSurveyMenos50': 'Go to survey -50',
          'auditMan': 'Auditoria manual',
          'libeCultureBrief': 'Breve divulgação da cultura',
          'lockRes': 'Resultados de bloqueio',
          'verCultureAudit': 'Ver Auditoria de Cultura',
          'verAvisos':'Comunicação pré-investigação',
          'enviaCorreos': 'Envie emails manualmente',
          'verWebComPro': 'Ver perfil da empresa na web',
          'verFechIniCie': 'Data de início / fim',
          'cancelarEnvios': 'Cancelar o envio de e-mails',
          'verConfigResult': 'Configuração dos resultados',
          'descaDemo': 'Permitir que os dados demográficos sejam descarregados',
          'crearClave':'Gerar chave para o perfil externo da empresa',
          'copyClave':'Copiar chave para o perfil externo da empresa',
          'verDatWPC':'Ver dados de acesso ao perfil externo da empresa',
          'confirReviCultureAudit':'Confirmar revisão de auditoria de cultura',
        },
        'MODALES': {
          'URL': 'Link copiado para a área de transferência',
          'URL_CLA': 'A chave foi copiada para a prancheta',
          'CHANGE_RESULT': 'Carregamento de resultados',
          'LOADINGMASTER': 'Recuperando informações da Mesa Mestre, por favor, aguarde um momento',
          'CONFIR_UPDA_NAM':'¿Você tem certeza de que quer atualizar o nome e o logotipo?',
          'CONFIR_REG_CERT': '¿Você tem certeza de regenerar o certificado?',
          'SUCC_UPDA_NAME':'Atualizado com sucesso',
          'UPDA_NAME_ICON':'Atualização de dados',
          'UPDA_STA_ENC':'Atualização do status da pesquisa',
          'OBT_DAT_AUD_AUT':'Obtenção de informações de auditoria',
          'WARNI_NOT_EXIT_TOKEN':'Erro: o token não existe na MT',
          'CONFIR_REPRO_RESULT': 'Você tem certeza de reprocessar os resultados?',
          'MOD_INGRE_COD_PT1':'<span> Para confirmar, digite o código em vermelho na caixa de texto ',
          'MOD_INGRE_COD_PT2':'</span>',
          'ERROR_CODIGO': 'O código inserido não corresponde ao indicado em vermelho',
          'CONFIR_LIBE_CULT_BRI':'Você tem certeza de divulgar o resumo da cultura?',
          'CONFIR_REVI_CULT_AUDIT':'Tem a certeza de confirmar a revisão da auditoria de cultura?',
          'NO_CONFIR_REVI_CULT_AUDIT':'Tem a certeza de cancelar a revisão da auditoria de cultura?',
          'NO_CULT_BRI_ASOC':'Um parceiro de auditoria cultural não pode ser encontrado',
          'BLOQUEAR_1_1': 'Os resultados estão desbloqueados no momento \nDeseja bloquear os resultados?',
          'BLOQUEAR_1_2': 'Insira o motivo pelo qual os resultados foram bloqueados',
          'BLOQUEAR_2_1': 'Os resultados estão bloqueados no momento \nVocê deseja desbloquear os resultados?',
          'BLOQUEAR_2_2': 'Escreva o motivo pelo qual os resultados foram desbloqueados',
          'BLOQUEAR_3_1': 'É necessário especificar o motivo da mudança',
          'SINCRONIZARMT': 'Os dados da Mesa Mestre estão sendo sincronizados, por favor aguarde um momento',
          'UPDA_DAT_RECOR': 'Atualizar a data do lembrete',
          'DELE_DAT_RECOR': 'Eliminar a data do lembrete',
          'UPDA_DAT_AVI': 'Atualização da data do aviso',
          'DELE_DAT_AVI': 'Eliminando a data do aviso',
          'CANCELAR_ENVIOS': 'Tem certeza de que deseja cancelar os e-mails programados?',
          'CANCELAR_ENVIOS_OK': 'O envio foi cancelado com sucesso.',
          'CANCELAR_ENVIOS_ERROR': 'Não é possível cancelar a entrega menos de duas horas antes do lançamento da pesquisa.',
          'COM_CRE_ACCE_WCP_EXT': 'Tem a certeza de criar a chave para o perfil da empresa?',
          'CRE_ACCE_WCP_EXT': 'Geração de senha',
          'SUCC_CRE_ACCE_WCP_EXT': 'Palavra-passe gerada com sucesso',
          'TIT_MOD_VALI_ACCE_WCP_EXT': 'Para continuar: Introduza a sua palavra-passe',
          'PLA1_MOD_VALI_ACCE_WCP_EXT': 'Actualmente ainda tem ',
          'PLA2_MOD_VALI_ACCE_WCP_EXT': ' tentativas',
          'BTN_ACEP': 'Aceitar',
          'BTN_CAN': 'Cancelar',
          'WAR_ACCE_WCP_EXT': 'A palavra-chave introduzida não está correcta',
          'LIMI_ACCE_WCP_EXT': 'Atingiu o limite das tentativas',
          'DESAC_ACCE_WCP_EXT': 'O perfil da sua empresa está actualmente desactivado',
          'ACTU_ACCE_WCP_EXT': 'Actualização de informação',
          'SUCC_ACTU_ACCE_ACCE_WCP_EXT': 'Actualizado com sucesso',
          'CHANGE_WCP':'Perfil da empresa que carrega',

        },
        'SUBACCIONES': {
          'TITULO': 'Clique aqui para ver mais ações disponíveis',
          'AUDMANUAL': {
            'TITULO': 'Auditoria manual',
            'NOMBRE': 'Nome do auditor',
            'NOTAS': 'Observações',
            'STATUS': {
              'ON': 'Auditoria aceita',
              'OFF': 'Auditoria rejeitada'
            }
          },
          'verRes': {
            'tipoResu': {
              'TITULO': 'Alterar o tipo de versão dos resultados',
              'MODAL': {
                'TITULO': 'Seleção do tipo de versão',
                'SUBTITULO': 'Selecione o tipo de versão de resultados para este produto',
                'SINCERT': 'Versão sem certificado',
                'CONCERT': 'Versão com certificado'
              }
            },
            'tipoResuV2': {
              'TITULO': 'Ver resultados versão 2',
            },
          },
          'regCertifi': {
            'logoCert': {
              'TITULO': 'Alterar logotipo do certificado',
            },
            'previewCert': {
              'TITULO': 'Pré-visualização do certificado',
            },
            'multiSite': {
              'TITULO': 'Habilitar texto de certificado multi-site',
            },
            'multiSiteText': {
              'TITULO': 'Ver o texto do certificado multi-site',
            },
          },
          'upNameIcon': {
            'logoEmpresa': {
              'TITULO': 'Alterar logotipo da empresa'
            },
            'previewLogoEmp': {
              'TITULO': 'Antevisão do logotipo'
            },
            'updateDatCerti': {
              'TITULO': 'Alterar data do certificado',
            }
          },
          'masterTable': {
            'syncMT': {
              'TITULO': 'Sincronizar Tabela Principal'
            }
          },
          'crearClave': {
            'visibleSwitchWCP': {
              'TITULO': 'Status ver perfil externo da empresa',
            }
          },
          'verDatWPC': {
            'visibleSwitchWCP': {
              'TITULO': 'Status ver perfil externo da empresa',
            }
          },
          'verWebComPro': {
            'updateStatusWCP': {
              'TITULO': 'Status ver perfil da empresa no site',
            },
            'ESTA_WPC':{
              'ESTA_WPC_PU':'Público',
              'ESTA_WPC_NPU':'Não-público',
            },
          },
        }
      },
      'HISTORIAL_MAILS': {
        'TAB': 'Histórico de e-mails enviados',
        'TITULO': 'Lista de e-mails enviados para este produto',
        'TABLA': {
          'DESTINATARIO': 'Destinatário',
          'ASUNTO': 'Assunto do correio',
          'ESTADO': 'Status atual',
          'VECES': 'Número de vezes aberto',
          'ULTIMO': 'Data do ultimo evento',
          'FILTRO': 'Filtro',
          'INPUT_DEST': 'Filtrar por endereço de e-mail',
          'INPUT_ASU': 'Filtrar por assunto',
          'INPUT_STAT': 'Filtrar por status',
          'ELIJAOPCION': '- Escolha uma opção da lista -',
          'NORESULTS': 'sem registros encontrados',
          'LISTA_STATUS': {
            'delivered': 'Enviei',
            'processed': 'Em processo de envio',
            'not_delivered': 'Não enviado'
          }
        },
        'ACCIONES': {
          'TITULO': 'Ações disponíveis',
          'LISTA': {
            'enviaCorreos': 'Envie emails manualmente',
            'getEnviados': 'Atualizar histórico de envio de e-mails',
          }
        },
        'MODAL': {
          'TITULO': 'Envio manual',
          'SUBTITULO': 'Você pode enviar correspondências manuais imediatas de um tipo específico para os colaboradores desta pesquisa',
          'INPUT': 'Selecione um tipo de e-mail',
          'TIPOS': {
            '1': 'E-mail de convite',
            '2': 'Email de lembrete',
            '3': 'Primeiro aviso antes de lançar a pesquisa',
            '4': 'Segundo aviso antes do lançamento da pesquisa',
            '5': 'Fechamento de Correio',
            '6': 'Correio enviado para colaboradores que ainda não iniciaram a pesquisa',
            '7': 'Correio enviado para colaboradores que começaram, mas não terminaram'
          },
          'BOTONES': {
            'BACK': 'Volte',
            'CONTINUAR': 'Continuar',
            'SAVE': 'Salvar auditoria'
          }
        },
        'MODALES': {
          'RECUPERANDO': 'Recuperando lista de e-mails enviados, espere um momento',
          'SEND_EMA':'Envio de e-mails',
          'SUCC_SEND_EMA': 'Os correios foram enviados com sucesso',
          'CONFIRMAR': 'Você confirma o envio dos emails do tipo selecionado para os colaboradores desta pesquisa?',
          'ENVIADOS': 'Os e-mails foram enviados com sucesso, atualize o histórico em breve para ver os e-mails enviados',
          'SI': 'sim',
          'NO': 'Não',
          'UPDAT_HIST_EMA': 'Atualização da história',
          'SUCC_UPDAT_HIST_EMA': 'Atualizado com sucesso',
          'WAR_SEL_MAI': 'Para continuar, selecione um tipo de correio',
          'WAR_SQL_ERROR': 'O tempo de resposta expirou, por favor tente novamente',
        },
        'RESUMEN': {
          'TITULO': 'Resumo',
          'TIPOS': {
            'totalEnviados': 'Total de correspondências iniciadas',
            'delivered': 'Correspondências corretas',
            'processed': 'Mailings em processo',
            'not_delivered': 'Mailings não feitos',
          }
        }
      },
      'AUDITORIA':{
        'TAB_TIT_AUDI':'Auditoria de pesquisa',
        'TEX_AUDI_NOT_AUTORI': 'Auditoria rejeitada!',
        'TEX_AUDI_YE_AUTORI': 'Auditoria aceita!',
        'TITL_AUDI_DEV_TR': '% Dev.Time Response',
        'TITL_AUDI_DEV_PC':'% Dev. Question Control',
        'TITL_AUDI_DEV_PA':'% Dev.  Pergunta Aleatória',
        'TIT_PAGI_TABL':'Artigos por página:',
        'COLUMNAS':{
          'HierarchicalPath':'Estrutura',
          'RespondentCount':'# Respostas',
          'Time_DeviationCount':'# Desv T.Resp',
          'Time_DeviationPercentage':'% Desv T.Resp',
          'ControlStatement_DeviationCount':'# Desv P.Controle',
          'ControlStatement_DeviationPercentage':'% Desv P.Controle',
          'RandomStatement_DeviationPercentage':'# Desv P.Aleatório',
          'RandomStatement_DeviationCount':'% Desv P.Aleatório',

        }
      },
      'EMAI_LOG':{
        'TAB': 'História geral do correio',
        'TABLA_GLOBAL':{
          'TITU': 'Exposição global',
          'SUB_TIT': 'Total de colaboradores',
          'TH_1': 'Status',
          'TH_2': 'Primeira notificação',
          'TH_3': 'Segunda notificação',
          'TH_4': 'Convite',
          'TH_5': 'Lembrete para usuários não iniciados',
          'TH_6': 'Lembrete para usuários inacabados',
          'enviados':'Enviados',
          'procesando': 'Processando',
          'erro': 'Erro',
          'VIE_DETA_TOOL':'Ver detalhes',

        },
        'TABLA_COLAB':{
          'TITU_AV1_DELIV': 'Exibição de aviso de envio 1 tipo de correio',
          'TITU_AV1_PROCC': 'Exibir notificação de tipo de correio 1 em processo',
          'TITU_AV1_N_DELIV': 'Exibir tipo de aviso de correio 1 em erro',

          'TITU_AV2_DELIV': 'Exibir tipo de aviso de correio 2 enviado',
          'TITU_AV2_N_DELIV': 'Exibir tipo de aviso de correio 2 em erro',
          'TITU_AV2_PROCC': 'Exibir notificação tipo 2 correio em processo',

          'TITU_INV_DELIV': 'Exibir tipo de convite enviado por correio',
          'TITU_INV_PROCC': 'Exibir tipo de correio convite em processo',
          'TITU_INV_N_DELIV': 'Exibir tipo de convite por engano',

          'TITU_REC1_DELIV': 'Mostrar lembrete de correio tipo 1 enviado',
          'TITU_REC1_PROCC': 'Mostrar lembrete 1 tipo de correio em processo',
          'TITU_REC1_N_DELIV': 'Mostrar lembrete 1 tipo de correio em erro',

          'TITU_REC2_DELIV': 'Mostrar lembrete de correio tipo 2 enviado',
          'TITU_REC2_N_DELIV': 'Mostrar o correio de lembrete tipo 2 em erro',
          'TITU_REC2_PROCC': 'Mostrar lembrete de correio tipo 2 em processo',
          'SUB_TIT': 'Total de colaboradores',
          'TH_1': 'Status',
          'TH_2': 'Nome do contribuinte',
          'TH_3':'Mensagem',
          'TH_4': 'Data do último e-mail',
          'TH_5': 'Total de e-mails',
          'TH_6': 'Ação',
          'processed':'Processed',
          'delivered':'Delivered',
          'open':'Open',
          'bounce':'Bounced',
          'dropped':'Dropped',
          'TEX_SEARC_COLAB':'Digite o nome ou e-mail',

        },
        'TEX_MOD_CHA_INFO':'Informações de carregamento',
        'CONT_MOD':{
          'TAB_TIT1': 'Status do correio',
            'TAB_TIT2': 'Visualização de correio',
            'TEX_CHA_INFO_GRAL': 'Informações de carregamento',
            'TEX_ASUN': 'Assunto: ',
            'TEX_SELEC_EMA': 'Selecione um e-mail',
            'TEX_CHA_INFO_EMA': 'Carregando informações de correio',
            'H1_TIT_EMA_INFO': 'Informações por e-mail',
            'SPAN_SUB_TIT_DET':'detalhes',
            "TO":'To:',
            'DE':'De:',
            'SUBJE': 'Assunto',
            'MESS_ID':'Message ID :',
            'BTN_VER_MAS':'Mais detalhes',
            'BTN_VER_MEN': 'Menos detalhes',
            'TIT_TEX_LIS': 'Histórico de eventos',
            'SPAN_RECIV_SENGR':'Recebido pela SendGrid',
            'SPAN_RECIV_FROM':'Recebido por ',
          'processed':'Processed',
          'delivered':'Delivered',
          'open':'Open',
          'bounce':'Bounced',
          'dropped':'Dropped',
          'deferred':'Deferred',
          'blocked':'blocked',
          'SPAN_DES_OPE_EMA':'O destinatário abriu este correio',
          'REASON':{
           'Bounced Address':'Endereço',
          }

        }
      },
      'DAT_CERTI':{
        'TIT_MOD': 'Modificar data do certificado',
        'ING_DAT':'Selecionar data:',
        'ING_RAS':'Insira a razão para modificar a data:',
        'BTN_SAV':'Salvar mudanças',
        'BTN_OK':'OK',
        'MOD_ING_REA': 'Insira o motivo da mudança de data',
        'MOD_UPD_DAT': 'Data de atualização do certificado',
        'SUCC_MOD_UPD_DAT': 'Atualizado com sucesso',

      },
      'DAT_STAEND':{
        'TIT_MOD': 'Data de início e fim da pesquisa',
        'SUB_TIT_MOD': 'Cada data é exibida na hora local em ',
        'TEX_DA_STA': 'Data de início',
        'TEX_DA_EN': 'Data final',
        'MOD_UPD_DA_DA_STA': 'Atualização da data de lançamento',
        'MOD_UPD_DA_EN': 'Atualização da data final',
        'SUCC_MOD_UPD_DA_DA_STA':'Atualização bem sucedida',
        'SUCC_MOD_UPD_DA_DA_EN': 'Atualizado com sucesso'

      },
      'LANG_CERT':{
        'TIT_MOD':'Seleccionar idioma: ',
      },
    }
};
